// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"843d5dbe","705":"d470f74f","970":"6785d1b9"}[chunkId] + ".chunk.js");